import { ICourseService } from "../../../core/services/course";
import { injectable } from "inversify";
import databaseInstance from "../../index";

@injectable()
export class LibraryService implements ICourseService {
  private dbInstance: any = databaseInstance;

  private static instance: LibraryService;

  constructor() {
    LibraryService.instance = this;
  }

  public static getInstance() {
    if (!LibraryService.instance) {
      LibraryService.instance = new LibraryService();
    }
    return LibraryService.instance;
  }

  public getContents: (groupId: number,
    type: string,
    page: number,
    query: string,
    published?: boolean,
    has_category?: boolean,
    community?: boolean,
  ) => Promise<void> = (groupId, type, page, query = '', published, has_category, community) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/groups/${groupId}/library-contents?${type.length > 0 ? `type=${type}` : ''}&page=${page}&search=${query}${published !== undefined ? `&published=${published}` : ''}${has_category !== undefined ? `&has_category=${has_category}` : ""}${community ? `&community=true` : ''}`)
        .then((response: any) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

  // public fetchPublicCourses: (groupId: number, query?: string) => Promise<void> = (groupId, query = '') => {
  //   return new Promise<void>((resolve, reject) => {
  //     this.dbInstance
  //       .get(`/groups/${groupId}/public/courses${query}`)
  //       .then((response: any) => {
  //         resolve(response);
  //       })
  //       .catch((error: any) => {
  //         reject(error)
  //         new Error("Something went wrong!")
  //       });
  //   });
  // };

  public getLibraryContents: (
    groupId: number,
    query?: string,
    admin?: boolean,
  ) => Promise<void> = (groupId, query = '', admin=false) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/groups/${groupId}/${admin ? 'admin-' : ''}library-contents${query}`)
        .then((response: any) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    })
  }

  public fetchPublicCourses: (groupId: number, query?: string) => Promise<void> = (groupId, query = '') => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/groups/${groupId}/public/courses${query}`)
        .then((response: any) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

  public getLibraryContentById: (
    groupId: number,
    contentId: number,
  ) => Promise<void> = (groupId, contentId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/groups/${groupId}/library-contents/${contentId}`)
        .then((response: any) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    })
  }

  public createLibraryContent: (
    groupId: number,
    contentData: any,
  ) => Promise<void> = (groupId, contentData) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .post(`/groups/${groupId}/library-contents`, contentData)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        })
    })
  }

  public publishLibraryContent: (
    contentType: string,
    contentId: number,
  ) => Promise<void> = (contentType, contentId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .post(`/${contentType}/${contentId}/publish`)
        .then(() => resolve())
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    })
  }

  public unpublishLibraryContent: (
    contentType: string,
    contentId: number,
  ) => Promise<void> = (contentType, contentId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .delete(`/${contentType}/${contentId}/publish`)
        .then(() => resolve())
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    })
  }

  public deleteLibraryContent: (
    groupId: number,
    contentType: string,
    contentId: number,
  ) => Promise<void> = (groupId, contentType, contentId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .delete(`/groups/${groupId}/${contentType}/${contentId}`)
        .then(() => resolve())
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    })
  }

  public editLibraryContent: (
    groupId: number,
    contentType: string,
    contentId: number,
    contentData: any,
  ) => Promise<void> = (groupId, contentType, contentId, contentData) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .put(`/groups/${groupId}/${contentType}/${contentId}`, contentData)
        .then(() => resolve())
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    })
  }

  public editArticleLibraryContent: (
    groupId: number,
    contentType: string,
    contentId: number,
    contentData: any,
  ) => Promise<void> = (groupId, contentType, contentId, contentData) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .put(`/groups/${groupId}/${contentType}/${contentId}`, contentData)
        .then(() => resolve())
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    })
  }

  public editLibraryContentThumbNail: (
    contentType: string,
    contentId: number,
    formData: any,
  ) => Promise<void> = (contentType, contentId, formData) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .post(`/${contentType}/${contentId}/thumbnail-image`, formData)
        .then(() => resolve())
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    })
  }

  public getLibraryContent: (
    groupId: number,
    contentType: any,
    contentId: any,
    query?: string,
  ) => Promise<void> = (groupId, contentType, contentId, query = "") => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/groups/${groupId}/${contentType}/${contentId}${query}`)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    })
  }

  public getLibraryItemAuthorizedUsers: (
    libraryItemType: string,
    libraryItemId: number,
    page?: number,
    query?: string
  ) => Promise<void> = (libraryItemType, libraryItemId, page = 1, query = "") => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/${libraryItemType}/${libraryItemId}/authorized-users?page=${page}${query.length > 0 ? `&search=${query}` : ""}`)
        .then((response: any) => {
          resolve(response);
        }).catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

  public addLibraryItemAuthorizedUser: (
    groupId: number,
    libraryItemId: number,
    userId: number
  ) => Promise<void> = (groupId, libraryItemId, userId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .post(`/groups/${groupId}/library-contents/${libraryItemId}/grant-access`, { user_id: userId })
        .then((response: any) => {
          resolve(response);
        }).catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

  public removeLibraryItemAuthorizedUser: (
    libraryItemType: string,
    libraryItemId: number,
    userId: number
  ) => Promise<void> = (libraryItemType, libraryItemId, userId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .delete(`/${libraryItemType}/${libraryItemId}/authorized-users`,
          {
            data: {
              user_id: userId
            }
          })
        .then((response: any) => {
          resolve(response);
        }).catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

  public getLibraryItemNonAccessibleUsers: (
    groupId: number,
    libraryItemType: string,
    libraryItemId: string,
    query?: string,
  ) => Promise<void> = (groupId, libraryItemType, libraryItemId, query = "") => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
       .get(
          `/groups/${groupId}/library-contents/${libraryItemId}/non-accesses?type=${libraryItemType}` +
          (query.trim().length > 0 ? `&search=${encodeURIComponent(query)}` : '')
        )
        .then((response: any) => {
          resolve(response);
        }).catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

  public loadMoreLibraryItemNonAuthorizedUsers: (
    groupId: number,
    libraryItemType: string,
    libraryItemId: string,
    pageNumber: number,
    query?: string,
  ) => Promise<void> = (groupId, libraryItemType, libraryItemId, pageNumber, query = "") => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/groups/${groupId}/library-contents/${libraryItemId}/non-accesses?type=${libraryItemType}&page=${pageNumber}` +
          (query.trim().length > 0 ? `&search=${encodeURIComponent(query)}` : '')
        )
        .then((response: any) => {
          resolve(response);
        }).catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

  public downloadLibraryItemAuthorizedUsers: (
    groupId: number,
    contentType: string,
    contentId: number,
  ) => Promise<void> = (groupId, contentType, contentId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .post(`/groups/${groupId}/library-contents/${contentId}/authorized-users/export`, {
          content_type: contentType,
        })
        .then((response: any) => {
          resolve(response);
        }).catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

  public shareContentPost: (
    contentId: number,
    postObject: any
  ) => Promise<void> = (contentId, postObject) => {
    return new Promise<void>((resolve, reject) => {
      return this.dbInstance
        .post(`/contents/${contentId}/posts`, postObject)
        .then((response: any) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

  public getContentPost: (contentType: string, contentId: number) => Promise<void> = (contentType, contentId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(
          `/${contentType}/${contentId}/posts?sort=published_at:desc`
        )
        .then((response: any) => {
          resolve(response);
        }).catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

  public getPinPostCourse: (contentType: string, contentId: number) => Promise<void> = (contentType, contentId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`${contentType}/${contentId}/posts/pinned`)
        .then((response: any) => {
          resolve(response);
        }).catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

  public pinPostCourse: (contentType: string, contentId: number, postId: number) => Promise<void> = (
    contentType,
    contentId,
    postId
  ) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .post(`${contentType}/${contentId}/posts/${postId}/pinned`)
        .then((response: any) => {
          resolve(response);
        }).catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

  public unpinPostCourse: (
    contentType: string,
    contentId: number,
    postId: number
  ) => Promise<void> = (contentType, contentId, postId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .delete(`${contentType}/${contentId}/posts/${postId}/pinned`)
        .then((response: any) => {
          resolve(response);
        }).catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

  public loadMoreContent: (url: string) => Promise<void> = (url) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(url)
        .then((response: any) => {
          resolve(response);
        }).catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    })
  }

  public accessLibraryItem: (
    groupId: number,
    contentId: number,
    metaData: any,
  ) => Promise<void> = (groupId, contentId, metaData) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .post(`/groups/${groupId}/library-contents/${contentId}/accesses`, metaData)
        .then(() => resolve())
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        })
    })
  }

  public getLibraryItemViewers: (
    groupId: number,
    contentId: number,
    query: string,
  ) => Promise<void> = (groupId, contentId, query) => {

    const url = `/groups/${groupId}/library-contents/${contentId}/accesses${query}`;

    // if (pageNumber !== undefined) {
    //   url += `&page=${pageNumber}`;
    // }
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(url)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public exportLibraryItemViewers: (
    groupId: number,
    contentId: number,
    contentType: string,
  ) => Promise<void> = (groupId, contentId, contentType) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .post(`/groups/${groupId}/library-contents/${contentId}/accesses/export`, {
          content_type: contentType,
        })
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    })
  }

  public enableEnforceLessonCompletion: (
    courseId: number,
  ) => Promise<void> = (courseId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .post(`/courses/${courseId}/content-completion`)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    })
  }

  public disableEnforceLessonCompletion: (
    courseId: number,
  ) => Promise<void> = (courseId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .delete(`/courses/${courseId}/content-completion`)
        .then(() => resolve())
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    })
  }

  public updateContentPositions: (
    groupId: number,
    payload: any,
  ) => Promise<void> = (groupId, payload) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .put(`/groups/${groupId}/library-contents/positions`, payload)
        .then((response: any) => resolve(response))
        .catch((error: Error) => {
          reject(error)
          new Error("Something went wrong!")
        })
    })
  }

  public grantUserLibraryAccess: (
    groupId: number,
    contentId: number,
    contentObj: any
  ) => Promise<void> = (groupId, contentId, contentObj) => {
    return new Promise<void>((resolve, reject) => {
      return this.dbInstance
        .post(`/groups/${groupId}/library-contents/${contentId}/accesses-by-admin`, contentObj)
        .then((response: any) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

  public deleteUserLibraryAccess: (
    groupId: number,
    contentId: number,
    contentObj: any
  ) => Promise<void> = (groupId, contentId, contentObj) => {
    return new Promise<void>((resolve, reject) => {
      return this.dbInstance
        .delete(`/groups/${groupId}/library-contents/${contentId}/accesses-by-admin`,
          {
            data: contentObj
          }
        )
        .then((response: any) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

  public createArticleContent: (
    groupId: number,
    articleId: number,
    articleObj: any
  ) => Promise<void> = (groupId, articleId, articleObj) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .post(`/groups/${groupId}/articles/${articleId}/content`, articleObj)
        .then((response: any) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

  public removeUserFromLib: (
    groupId: number,
    contentId: number,
    contentObj: any
  ) => Promise<void> = (groupId, contentId, contentObj) => {
    return new Promise<void>((resolve, reject) => {
      return this.dbInstance
        .delete(`/groups/${groupId}/library-contents/${contentId}/accesses-by-admin`,
          {
            data: contentObj
          }
        )
        .then((response: any) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

  public expireUserAccess: (
    groupId: number,
    accessesId: number,
    payload?: any
  ) => Promise<void> = (groupId, accessesId, payload) => {
    return new Promise<void>((resolve, reject) => {
      return this.dbInstance
        .post(`/groups/${groupId}/accesses/${accessesId}/expire`, payload)
        .then((response: any) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

  public activateUserAccess: (
    groupId: number,
    accessesId: number,
    payload: any
  ) => Promise<void> = (groupId, accessesId, payload) => {
    return new Promise<void>((resolve, reject) => {
      return this.dbInstance
        .post(`/groups/${groupId}/accesses/${accessesId}/activate`, payload)
        .then((response: any) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

  public getSpecificContent: (
    groupId: number,
    type: string,
    query: string,
  ) => Promise<void> = (groupId, type, query) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/groups/${groupId}/admin-library-contents?type=${type}&search=${encodeURIComponent(query)}`)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

  public sortLibraryContents: (groupId: number,query: string) => Promise<any> = (groupId: number, query: string) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/groups/${groupId}/admin-library-contents${query}`)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

  public getAdminContents: (
    groupId: number,
    // type: string,
    // page: number,
    query: string,
  ) => Promise<void> = (groupId, query) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/groups/${groupId}/admin-library-contents${query}`)
        .then((response: any) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

  public createAdminLibraryContent: (
    groupId: number,
    contentData: any,
  ) => Promise<void> = (groupId, contentData) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .post(`/groups/${groupId}/admin-library-contents`, contentData)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        })
    })
  }
}
